import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Star } from "lucide-react";
import { rErr, rPost } from "@/lib/radar";

// Team-shared watchlist (§50). Falls back to this device until POST /companies/{id}/star is live.
const KEY = "rpopro_radar_stars";
const EVT = "rpopro:stars";
const readLocal = () => { try { return JSON.parse(localStorage.getItem(KEY) || "{}"); } catch { return {}; } };
let over = {}; // optimistic + local values, shared across components
const emit = () => window.dispatchEvent(new Event(EVT));

export const useStars = () => {
  const [, set] = useState(0);
  useEffect(() => { const f = () => set((n) => n + 1); window.addEventListener(EVT, f); return () => window.removeEventListener(EVT, f); }, []);
  const local = readLocal();
  const isStarred = (c) => (c.id in over ? over[c.id] : c.id in local ? local[c.id] : !!c.starred);
  const toggle = async (c) => {
    const v = !isStarred(c);
    over = { ...over, [c.id]: v }; emit();
    try { await rPost(`/companies/${c.id}/star`, { starred: v }); }
    catch (e) {
      if (e.response?.status === 404) {
        localStorage.setItem(KEY, JSON.stringify({ ...readLocal(), [c.id]: v }));
        toast.message("Starred on this device for now. It will be shared with your team once the backend adds starring (§50).");
      } else { over = { ...over, [c.id]: !v }; emit(); toast.error(rErr(e)); }
    }
  };
  const pin = (items) => [...items].sort((a, b) => (isStarred(b) ? 1 : 0) - (isStarred(a) ? 1 : 0));
  return { isStarred, toggle, pin };
};

export const StarBtn = ({ c, stars, size = "h-4 w-4", testid }) => {
  const on = stars.isStarred(c);
  return (
    <button onClick={(e) => { e.stopPropagation(); e.preventDefault(); stars.toggle(c); }} title={on ? "Remove from watchlist" : "Add to watchlist"} aria-pressed={on} className="shrink-0 rounded p-0.5 transition-transform hover:scale-110" data-testid={testid || `radar-star-${c.id}`}>
      <Star className={`${size} ${on ? "fill-[#D4AF37] text-[#D4AF37]" : "text-zinc-600 hover:text-[#D4AF37]"}`} />
    </button>
  );
};
